import { Base } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/framework/base";
import { IdTitleNode, IIdTitleNode } from "../../../../../QTeamSystems.QTeamIntra.Ui/Scripts/source/models/common/idTitleNode";
import { ModulePartnerEditItem, IModulePartnerEditItem } from "./modulePartnerEditItem";

export interface IModulePartnerEdit {
    units: IIdTitleNode[];
    partner: IModulePartnerEditItem;
}

export class ModulePartnerEdit implements IModulePartnerEdit {
    units: IdTitleNode[];
    partner: ModulePartnerEditItem;

    constructor();
    constructor(obj: IModulePartnerEdit);
    constructor(obj?: any) {
        this.partner = new ModulePartnerEditItem(obj?.partner);
        this.units = Base.getTypedArray(obj?.units, IdTitleNode);
    }
}